// @flow 
import {Fragment, useEffect, useState} from 'react';
import * as React from 'react';
import {PaginationComponent} from '../../../components/ui/PaginationComponent';
import {getPages, paginate} from '../../../util/paginate';
import {UserComponent} from './UserComponent';

interface Props {
  users: IManagedUser[]
  flipNotifyUser: (userId: number) => void
  editUser: (userId: number) => void
  popupDeleteUserModal: (user: IManagedUser) => void
  openUpdatePasswordModal: (user: IManagedUser) => void
  hideActionAlertDashboardCount: boolean
}

export const UsersList = (props: Props) => {
  const {
    users,
    flipNotifyUser,
    editUser,
    popupDeleteUserModal,
    openUpdatePasswordModal,
    hideActionAlertDashboardCount,
  } = props;
  
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPagerPage, setCurrentPagerPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [paginatedUsers, setPaginatedUsers] = useState(paginate(users, 1, 10))

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    setPaginatedUsers(paginate(users, pageNumber, pageSize))
  }

  const handlePageSizeChange = (pageSize: number) => {
      setCurrentPage(1)
      setPageSize(pageSize)
      setPaginatedUsers(paginate(users, 1, pageSize))
  }

  useEffect(() => {
    handlePageChange(currentPage)
    // handlePageSizeChange(pageSize)
  }, [users])

  return (
    <Fragment>
      <PaginationComponent
        onPageChange={(pageNumber) => {
          handlePageChange(pageNumber);
        }}
        onPageSizeChange={(pageSize) => {
          handlePageSizeChange(pageSize);
        }}
        itemsCount={users.length}
        currentPage={currentPage}
        pageSize={pageSize}
        pages={getPages(users.length, pageSize)}
      />
      {paginatedUsers.map((u, idx) => {
        return (
          <UserComponent
            key={u.id}
            user={u}
            isOdd={idx % 2 === 1}
            flipNotifyUser={(userId) => {
              flipNotifyUser(userId);
            }}
            editUser={(userId) => {
              editUser(userId);
            }}
            popupDeleteUserModal={(user) => {
              popupDeleteUserModal(user);
            }}
            openUpdatePasswordModal={(user) => {
              openUpdatePasswordModal(user);
            }}
            hideActionAlertDashboardCount = {hideActionAlertDashboardCount}
          />
        );

      })}
    </Fragment>
  );
};
